<template>
  <v-card-text style="overflow-y: auto; height: auto">
    <v-row class="pt-10" justify="center">
      <span class="text-333333 w-700 font-18">แบบบันทึกและติดตามการเยี่ยมบ้าน</span>
    </v-row>
    <v-form ref="form4">
      <v-row class="pt-3">
        <v-col cols="12" class="d-flex d-flex-row">
          <span class="pb-2 w-700 font-16 text-333333 pr-3 align-self-center" style="white-space: nowrap;">กิจกรรมการพยาบาล</span>
          <v-row no-gutters>
            <span class="pb-2 w-500 font-16 text-333333 pr-3 align-self-center" style="white-space: nowrap;">ครั้งที่ :</span>
            <span class="pb-2 w-500 font-16 text-333333 pr-3 align-self-center" style="white-space: nowrap;">{{nursing_activity_no.no || '-'}}</span>

            <span class="pb-2 w-500 font-16 text-333333 pr-3 align-self-center" style="white-space: nowrap;">วันที่ :</span>
            <span class="pb-2 w-500 font-16 text-333333 pr-3 align-self-center" style="white-space: nowrap;">{{displayDate(nursing_activity_no.date) || '-'}}</span>

            <span class="pb-2 w-500 font-16 text-333333 pr-3 align-self-center" style="white-space: nowrap;">เวลาที่เยี่ยมบ้าน :</span>
            <span class="pb-2 w-500 font-16 text-333333 pr-3 align-self-center" style="white-space: nowrap;">{{nursing_activity_no.visit_time || '00.00'}} น.</span>
              
            <span class="pb-2 w-500 font-16 text-333333 pr-3 align-self-center" style="white-space: nowrap;">เวลาที่สิ้นสุดการเยี่ยม :</span>
            <span class="pb-2 w-500 font-16 text-333333 pr-3 align-self-center" style="white-space: nowrap;">{{nursing_activity_no.end_time || '00.00'}} น.</span>
          </v-row>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pt-0">
          <span class="w-700 font-16 text-333333 pr-3 align-self-center" style="white-space: nowrap;">ประเภทผู้ป่วย </span>
          <span class="w-500 font-16 text-333333 pr-3 align-self-center" style="white-space: nowrap;">{{patient_type.id || '-'}} {{patient_type.title}}</span>
        </v-col>
      </v-row>
      <v-row class="pt-0">
        <v-col cols="12">
          <span class="w-700 font-16 text-333333 pr-3 align-self-center" style="white-space: nowrap;">ข้อบ่งชี้/เหตุผลในการเยี่ยมบ้าน </span>
          <span class="w-500 font-16 text-333333 pr-3 align-self-center" style="white-space: nowrap;">{{reason_visit_home || '-'}}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-divider></v-divider>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pb-0 d-flex d-flex-row">
          <v-row no-gutters>
            <v-row no-gutters class="pb-2">
              <span class="pt-2 w-700 font-16 text-333333 pr-3">V/S T</span>
              <span class="pt-2 w-500 font-16 text-333333 pr-3">{{V_S.T.value_1 || '0'}}</span>
              <span class="pt-2 w-700 font-16 text-333333 pr-3">C</span>
            </v-row>
            <v-row no-gutters class="pb-2">
              <span class="pt-2 w-700 font-16 text-333333 pr-3">BP (1)</span>
              <span class="pt-2 w-500 font-16 text-333333 pr-0">{{V_S.BP_1.value_1 || '0'}}</span>
              <span class="pt-2 w-700 font-16 text-333333 px-3">/</span>
              <span class="pt-2 w-500 font-16 text-333333 pr-3">{{V_S.BP_1.value_2 || '0'}}</span>
              <span class="pt-2 w-700 font-16 text-333333 pr-3">mm.Hg</span>
            </v-row>
            <v-row no-gutters class="pb-2">
              <span class="pt-2 w-700 font-16 text-333333 pr-3">BP (2)</span>
              <span class="pt-2 w-500 font-16 text-333333 pr-0">{{V_S.BP_2.value_1 || '0'}}</span>
              <span class="pt-2 w-700 font-16 text-333333 px-3">/</span>
              <span class="pt-2 w-500 font-16 text-333333 pr-3">{{V_S.BP_2.value_2 || '0'}}</span>
              <span class="pt-2 w-700 font-16 text-333333 pr-3">mm.Hg</span>
            </v-row>
            <v-row no-gutters class="pb-2">
              <span class="pt-2 w-700 font-16 text-333333 pr-3">RR</span>
              <span class="pt-2 w-500 font-16 text-333333 pr-3">{{V_S.RR.value_1 || '0'}}</span>
              <span class="pt-2 w-700 font-16 text-333333 pr-3">/min.</span>
            </v-row>
            <v-row no-gutters class="pb-2">
              <span class="pt-2 w-700 font-16 text-333333 pr-3">PR</span>
              <span class="pt-2 w-500 font-16 text-333333 pr-3">{{V_S.PR.value_1 || '0'}}</span>
              <span class="pt-2 w-700 font-16 text-333333 pr-3">/min.</span>
            </v-row>
            <v-row no-gutters class="pb-2">
              <span class="pt-2 w-700 font-16 text-333333 pr-3">BW</span>
              <span class="pt-2 w-500 font-16 text-333333 pr-3">{{V_S.BW.value_1 || '0'}}</span>
              <span class="pt-2 w-700 font-16 text-333333 pr-3">Kg</span>
            </v-row>
            <v-row no-gutters class="pb-2">
              <span class="pt-2 w-700 font-16 text-333333 pr-3">HT</span>
              <span class="pt-2 w-500 font-16 text-333333 pr-3">{{V_S.HT.value_1 || '0'}}</span>
              <span class="pt-2 w-700 font-16 text-333333 pr-3">Cm</span>
            </v-row>
          </v-row>
        </v-col>
      </v-row>
      <v-row class="pb-3">
        <v-col cols="12" class="d-flex d-flex-row">
          <span class="pt-1 pr-6 w-500 font-16 text-333333 align-self-start">ประเมินสภาพทั่วไป :</span>
          <span class="pt-1 pr-6 w-500 font-16 text-333333 align-self-start">{{general_condition.title || '-'}}</span>
          <span class="pt-1 pr-6 w-500 font-16 text-333333 align-self-start"><span class="pt-1 w-500 font-16 text-333333 align-self-start" v-if="general_condition.status == '2'">ระบุ </span>{{general_condition.detail}}</span>
        </v-col>
      </v-row>
      <div v-if="display_vuetify !== 'xs'" style="min-height: 310px; max-height: 500px;overflow-x: hidden;overflow-y: auto;">
        <v-row v-for="(item, index) in problems" :key="index" class="pr-8 pl-3 py-3">    
          <v-col cols="12" class="pa-0">
            <v-row no-gutters>
              <span class="py-2 text-333333 font-18 w-700">รายการที่ {{ index + 1 }}.</span>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12" xl="3" lg="3" md="3" sm="3" class="px-0">
                <v-card color="#00A99D" class="border-card-00A99D" flat tile>
                  <v-card-title class="py-8 px-3">
                    <v-row class="justify-center">
                      <span class="w-500 font-16 text-ffffff" style="white-space: nowrap;">ปัญหาที่พบ</span>
                    </v-row>
                  </v-card-title>
                  <v-card-text class="pa-0 bg-white" style="border: 1px solid #00A99D;border-right: 0;">
                    <v-textarea
                      hide-details="auto"
                      placeholder="ระบุปัญหาที่พบ"
                      class="px-1 pt-0"
                      v-model="item.problems_encountered"
                      color="#00A99D"
                      readonly
                    ></v-textarea>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" xl="3" lg="3" md="3" sm="3" class="px-0">
                <v-card color="#00A99D" class="border-card-00A99D" flat tile>
                  <v-card-title class="py-8 px-3">
                    <v-row class="justify-center">
                      <span class="w-500 font-16 text-ffffff" style="white-space: nowrap;">เป้าหมายการพยาบาล</span>
                    </v-row>
                  </v-card-title>
                  <v-card-text class="pa-0 bg-white" style="border: 1px solid #00A99D;border-right: 0;border-left: 0;">
                    <v-textarea
                      hide-details="auto"
                      placeholder="ระบุเป้าหมายการพยาบาล"
                      class="px-1 pt-0"
                      v-model="item.nursing_goals"
                      color="#00A99D"
                      readonly
                    ></v-textarea>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" xl="3" lg="3" md="3" sm="3" class="px-0">
                <v-card color="#00A99D" class="border-card-00A99D" flat tile>
                  <v-card-title class="py-8 px-3">
                    <v-row class="justify-center">
                      <span class="w-500 font-16 text-ffffff" style="white-space: nowrap;">การพยาบาล/ช่วยเหลือ</span>
                    </v-row>
                  </v-card-title>
                  <v-card-text class="pa-0 bg-white" style="border: 1px solid #00A99D;border-right: 0;border-left: 0;">
                    <v-textarea
                      hide-details="auto"
                      placeholder="ระบุการพยาบาล/ช่วยเหลือ"
                      class="px-1 pt-0"
                      v-model="item.nursing"
                      color="#00A99D"
                      readonly
                    ></v-textarea>
                  </v-card-text>
                </v-card>
              </v-col>
              <v-col cols="12" xl="3" lg="3" md="3" sm="3" class="px-0">
                <v-card color="#00A99D" class="border-card-00A99D" flat tile>
                  <v-card-title class="py-8 px-3">
                    <v-row class="justify-center">
                      <span class="w-500 font-16 text-ffffff" style="white-space: nowrap;">ผลการพยาบาล/ประเมินผล</span>
                    </v-row>
                  </v-card-title>
                  <v-card-text class="pa-0 bg-white" style="border: 1px solid #00A99D;border-right: 0;">
                    <v-textarea
                      hide-details="auto"
                      placeholder="ระบุผลการพยาบาล/ประเมินผล"
                      class="px-1 pt-0"
                      v-model="item.nursing_results"
                      color="#00A99D"
                      readonly
                    ></v-textarea>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </div>
      <v-row v-else>
        <v-col cols="12">
          <v-window reverse v-model="slide">
            <template v-slot:prev="{ on, attrs }">
              <v-btn fab x-small text v-bind="attrs" v-on="on" color="#00A99D" @click="prev"><v-icon color="#00A99D">mdi-chevron-left</v-icon></v-btn>
            </template>
            <template v-slot:next="{ on, attrs }">
              <v-btn fab x-small v-bind="attrs" v-on="on" text color="#00A99D" @click="next"><v-icon color="#00A99D">mdi-chevron-right</v-icon></v-btn>
            </template>
            <v-window-item v-for="(item, index) in problems" :key="index">
              <v-row>
                <v-col cols="12" class="pb-0">
                  <v-row no-gutters>
                    <span class="py-2 text-333333 font-18 w-700">รายการที่ {{ index + 1 }} / {{ problems.length }}</span>
                  </v-row>
                  <v-row>
                    <v-col cols="12" xl="3" lg="3" md="3" sm="3" class="pt-0">
                      <v-card color="#00A99D" class="border-card-00A99D" flat tile>
                        <v-card-title class="py-8 px-3">
                          <v-row class="justify-center">
                            <span class="w-500 font-16 text-ffffff" style="white-space: nowrap;">ปัญหาที่พบ</span>
                          </v-row>
                        </v-card-title>
                        <v-card-text class="pa-0 bg-white" style="border: 1px solid #00A99D;border-right: 0;">
                          <v-textarea
                            hide-details="auto"
                            placeholder="ระบุปัญหาที่พบ"
                            class="px-1 pt-0"
                            v-model="item.problems_encountered"
                            color="#00A99D"
                            readonly
                          ></v-textarea>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" xl="3" lg="3" md="3" sm="3" class="pt-0">
                      <v-card color="#00A99D" class="border-card-00A99D" flat tile>
                        <v-card-title class="py-8 px-3">
                          <v-row class="justify-center">
                            <span class="w-500 font-16 text-ffffff" style="white-space: nowrap;">เป้าหมายการพยาบาล</span>
                          </v-row>
                        </v-card-title>
                        <v-card-text class="pa-0 bg-white" style="border: 1px solid #00A99D;border-right: 0;border-left: 0;">
                          <v-textarea
                            hide-details="auto"
                            placeholder="ระบุเป้าหมายการพยาบาล"
                            class="px-1 pt-0"
                            v-model="item.nursing_goals"
                            color="#00A99D"
                            readonly
                          ></v-textarea>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" xl="3" lg="3" md="3" sm="3" class="pt-0">
                      <v-card color="#00A99D" class="border-card-00A99D" flat tile>
                        <v-card-title class="py-8 px-3">
                          <v-row class="justify-center">
                            <span class="w-500 font-16 text-ffffff" style="white-space: nowrap;">การพยาบาล/ช่วยเหลือ</span>
                          </v-row>
                        </v-card-title>
                        <v-card-text class="pa-0 bg-white" style="border: 1px solid #00A99D;border-right: 0;border-left: 0;">
                          <v-textarea
                            hide-details="auto"
                            placeholder="ระบุการพยาบาล/ช่วยเหลือ"
                            class="px-1 pt-0"
                            v-model="item.nursing"
                            color="#00A99D"
                            readonly
                          ></v-textarea>
                        </v-card-text>
                      </v-card>
                    </v-col>
                    <v-col cols="12" xl="3" lg="3" md="3" sm="3" class="pt-0">
                      <v-card color="#00A99D" class="border-card-00A99D" flat tile>
                        <v-card-title class="py-8 px-3">
                          <v-row class="justify-center">
                            <span class="w-500 font-16 text-ffffff" style="white-space: nowrap;">ผลการพยาบาล/ประเมินผล</span>
                          </v-row>
                        </v-card-title>
                        <v-card-text class="pa-0 bg-white" style="border: 1px solid #00A99D;border-right: 0;">
                          <v-textarea
                            hide-details="auto"
                            placeholder="ระบุผลการพยาบาล/ประเมินผล"
                            class="px-1 pt-0"
                            v-model="item.nursing_results"
                            color="#00A99D"
                            readonly
                          ></v-textarea>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="12">
                  <v-item-group
                    v-model="slide"
                    class="text-center"
                    mandatory
                  >
                    <v-item
                      v-for="n in problems.length"
                      :key="`btn-${n}`"
                      v-slot="{ active, toggle }"
                    >
                      <v-btn
                        :input-value="active"
                        icon
                        @click="toggle"
                        color="#00A99D"
                        x-small
                      >
                        <v-icon>mdi-record</v-icon>
                      </v-btn>
                    </v-item>
                  </v-item-group>
                </v-col>
              </v-row>
            </v-window-item>
          </v-window>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pt-5">
          <span class="w-700 font-16 text-333333 pr-3">แผนการเยี่ยมครั้งต่อไป</span>
          <span class="w-500 font-16 text-333333 pr-3">{{next_visit_plans || '-'}}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="d-flex d-flex-row">
          <span class="w-700 font-16 text-333333 pr-6 align-self-center">นัดครั้งต่อไป</span><span class="w-700 font-16 text-333333 pr-3 align-self-center">วันที่</span>
          <span class="w-500 font-16 text-333333 pr-3">{{displayDate2(next_visit_time) || '-'}}</span>
        </v-col>
      </v-row>
      <v-row class="pt-5 d-flex d-flex-row">
        <v-col cols="12" xl="8" lg="8" md="6" sm="6" class="pb-8">
          <v-row>
            <v-col cols="9" xl="3" lg="3" md="6" class="py-0 ml-6">
              <v-row fill-height height="80px">
                <v-col cols="12" align-self="center" align="center">
                  <v-avatar
                    width="auto"
                    height="auto"
                    tile
                  >
                    <v-img v-if="user.signature_user" :src="user.signature_user"></v-img>
                  </v-avatar>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="py-0">
              <span class="w-700 font-16 text-333333">ลงชื่อ........................................................ผู้รับบริการ</span>
            </v-col>
            <v-col cols="12" class="py-0 pl-16">
              <span class="w-700 font-16 text-333333">( {{ user.name }} )</span>
            </v-col>
          </v-row>
        </v-col>

        <v-col cols="12" xl="4" lg="4" md="6" sm="6" class="pb-8">
          <v-row>
            <v-col cols="9" xl="6" lg="6" md="6" class="py-0 ml-4">
              <v-row fill-height height="80px">
                <v-col cols="12" align-self="center" align="center">
                  <v-avatar
                    width="auto"
                    height="auto"
                    tile
                  >
                    <v-img v-if="staff_service.signature_staff" :src="staff_service.signature_staff"></v-img>
                  </v-avatar>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="12" class="py-0">
              <span class="w-700 font-16 text-333333">ลงชื่อ........................................................ตำแหน่ง {{ staff_service.position  || ''}} ผู้เยี่ยม/ผู้รับผิดชอบ</span>
            </v-col>
            <v-col cols="12" class="py-0 pl-16">
              <span class="w-700 font-16 text-333333">( {{ staff_service.name  || ''}} )</span>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <v-row class="pt-5">
        <v-col cols="12">
          <v-row>
            <v-col cols="auto">
            <span class="w-700 font-16 text-333333">เอกสารเพิ่มเติม : </span><span class="font-14 text-333333" v-if="span_files == true">ไม่พบเอกสาร</span>
            </v-col>
            <v-col cols="12" xl="10" lg="10" md="12" sm="12">
              <v-row v-for="(item, index) in files" :key="index"  class="pt-2 pl-2">
                <v-chip color='#ceefed' @click="downloadFile(index)">
                  <v-col cols="12">
                    <v-icon color='#00A99D'>mdi-progress-download</v-icon>
                    <span class="pl-5 text-333333">{{item.filename}}</span>
                  </v-col>
                </v-chip>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </v-card-text>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      item: {},
      day_menu: false,
      isWrite: false,
      isWrite2: false,
      dateNow: moment().format("YYYY-MM-DD"),
      activePicker: null,
      set_hour: [],
      set_min: [],
      hour_start: '',
      min_start: '',
      hour_end: '',
      min_end: '',
      day_menu2: false,
      date2: moment().add(1, 'days').format("YYYY-MM-DD"),
      activePicker2: null,
      slide: 0,
      files: [],
      authen_token: '',
      span_files: false,
      
      nursing_activity_no: {
        no: '1',
        date: moment().format("YYYY-MM-DD"),
        visit_time: '',
        end_time: ''
      },
      patient_type: {
        status: '',
        id: '',
        title: ''
      },
      reason_visit_home: '',
      V_S: {
        T: {
          value_1: ''
        },
        BP_1: {
          value_1: '',
          value_2: ''
        },
        BP_2: {
          value_1: '',
          value_2: ''
        },
        RR: {
          value_1: ''
        },
        PR: {
          value_1: ''
        },
        BW: {
          value_1: ''
        },
        HT: {
          value_1: ''
        },
      },
      general_condition: {
        status: '',
        title: '',
        detail: ''
      },
      problems: [],
      // problems_encountered: '',
      // nursing_goals: '',
      // nursing: '',
      // nursing_results: '',
      next_visit_plans: '',
      next_visit_time: moment().add(1, 'days').format("YYYY-MM-DD"),
      reciver_service_name: '',
      user: {
        signature_user: ''
      },
      staff_service: {
        name: sessionStorage.getItem('accountName'),
        position:sessionStorage.getItem('role_name'),
        signature_staff: ''
      },
      rules_checkbox: [(v) => !!v || "กรุณาเลือกข้อมูล"],
      rules_detail: [(v) => !!v || "กรุณาระบุข้อมูล"],
      user_image_HTML: "",
      staff_image_HTML: "",
    }
  },
  computed: {
    x_mobile: {
      get: function () {
        if (this.$vuetify.breakpoint.width <= 820) {
          return true;
        } else {
          return false;
        }
      },
      set: function (newValue) {
        this.nav = newValue;
      },
    },
    phone() {
      if (this.$vuetify.breakpoint.width < 450) {
        return true;
      } else {
        return false;
      }
    },
    tablet() {
      if (this.$vuetify.breakpoint.width <= 820) {
        return true;
      } else {
        return false;
      }
    },
    display_vuetify() {
      return this.$vuetify.breakpoint.name
    },
  },
  async created() {
    await this.set_value()

  },
  methods: {
    async openPage(item, value, home_visit) {
      // console.log('res home_visit', home_visit);
      this.item = item
      // console.log('this.item', this.item);s
      this.hour_start = home_visit !== null && 'nursing_activity_no' in home_visit && 'visit_time' in home_visit.nursing_activity_no && home_visit.nursing_activity_no.visit_time !== '' && home_visit.nursing_activity_no.visit_time !== null && home_visit.nursing_activity_no.visit_time !== undefined ? home_visit.nursing_activity_no.visit_time.substring(0, 2) : ''
      this.min_start = home_visit !== null && 'nursing_activity_no' in home_visit && 'visit_time' in home_visit.nursing_activity_no && home_visit.nursing_activity_no.visit_time !== '' && home_visit.nursing_activity_no.visit_time !== null && home_visit.nursing_activity_no.visit_time !== undefined ? home_visit.nursing_activity_no.visit_time.substring(3, 5) : ''
      this.hour_end = home_visit !== null && 'nursing_activity_no' in home_visit && 'end_time' in home_visit.nursing_activity_no && home_visit.nursing_activity_no.end_time !== '' && home_visit.nursing_activity_no.end_time !== null && home_visit.nursing_activity_no.end_time !== undefined ? home_visit.nursing_activity_no.end_time.substring(0, 2) : ''
      this.min_end = home_visit !== null && 'nursing_activity_no' in home_visit && 'end_time' in home_visit.nursing_activity_no && home_visit.nursing_activity_no.end_time !== '' && home_visit.nursing_activity_no.end_time !== null && home_visit.nursing_activity_no.end_time !== undefined ? home_visit.nursing_activity_no.end_time.substring(3, 5) : ''

      this.set_value()
      
      this.nursing_activity_no = {
        no: home_visit !== null && 'nursing_activity_no' in home_visit && 'no' in home_visit.nursing_activity_no && home_visit.nursing_activity_no.no !== '' && home_visit.nursing_activity_no.no !== null && home_visit.nursing_activity_no.no !== undefined ? home_visit.nursing_activity_no.no : '',
        date: home_visit !== null && 'nursing_activity_no' in home_visit && 'date' in home_visit.nursing_activity_no && home_visit.nursing_activity_no.date !== '' && home_visit.nursing_activity_no.date !== null && home_visit.nursing_activity_no.date !== undefined ? home_visit.nursing_activity_no.date : moment().format("YYYY-MM-DD"),
        visit_time: home_visit !== null && 'nursing_activity_no' in home_visit && 'visit_time' in home_visit.nursing_activity_no && home_visit.nursing_activity_no.visit_time !== '' && home_visit.nursing_activity_no.visit_time !== null && home_visit.nursing_activity_no.visit_time !== undefined ? home_visit.nursing_activity_no.visit_time : '',
        end_time: home_visit !== null && 'nursing_activity_no' in home_visit && 'end_time' in home_visit.nursing_activity_no && home_visit.nursing_activity_no.end_time !== '' && home_visit.nursing_activity_no.end_time !== null && home_visit.nursing_activity_no.end_time !== undefined ? home_visit.nursing_activity_no.end_time : '',
      }

      this.patient_type = {
        status: home_visit !== null && 'patient_type' in home_visit && 'status' in home_visit.patient_type && home_visit.patient_type.status !== '' && home_visit.patient_type.status !== null && home_visit.patient_type.status !== undefined ? home_visit.patient_type.status : '',
        id: home_visit !== null && 'patient_type' in home_visit && 'id' in home_visit.patient_type && home_visit.patient_type.id !== '' && home_visit.patient_type.id !== null && home_visit.patient_type.id !== undefined ? home_visit.patient_type.id : '',
        title: home_visit !== null && 'patient_type' in home_visit && 'title' in home_visit.patient_type && home_visit.patient_type.title !== '' && home_visit.patient_type.title !== null && home_visit.patient_type.title !== undefined ? home_visit.patient_type.title : '',
      }

      this.reason_visit_home = home_visit !== null && 'reason_visit_home' in home_visit && home_visit.reason_visit_home !== '' && home_visit.reason_visit_home !== null && home_visit.reason_visit_home !== undefined ? home_visit.reason_visit_home : '',

      this.V_S = {
        T: {
          value_1: home_visit !== null && 'V_S' in home_visit && 'T' in home_visit.V_S && 'value_1' in home_visit.V_S.T && home_visit.V_S.T.value_1 !== '' && home_visit.V_S.T.value_1 !== null && home_visit.V_S.T.value_1 !== undefined ? home_visit.V_S.T.value_1 : ''
        },
        BP_1: {
          value_1: home_visit !== null && 'V_S' in home_visit && 'BP_1' in home_visit.V_S && 'value_1' in home_visit.V_S.BP_1 && home_visit.V_S.BP_1.value_1 !== '' && home_visit.V_S.BP_1.value_1 !== null && home_visit.V_S.BP_1.value_1 !== undefined ? home_visit.V_S.BP_1.value_1 : '',
          value_2: home_visit !== null && 'V_S' in home_visit && 'BP_1' in home_visit.V_S && 'value_2' in home_visit.V_S.BP_1 && home_visit.V_S.BP_1.value_2 !== '' && home_visit.V_S.BP_1.value_2 !== null && home_visit.V_S.BP_1.value_2 !== undefined ? home_visit.V_S.BP_1.value_2 : ''
        },
        BP_2: {
          value_1: home_visit !== null && 'V_S' in home_visit && 'BP_2' in home_visit.V_S && 'value_1' in home_visit.V_S.BP_2 && home_visit.V_S.BP_2.value_1 !== '' && home_visit.V_S.BP_2.value_1 !== null && home_visit.V_S.BP_2.value_1 !== undefined ? home_visit.V_S.BP_2.value_1 : '',
          value_2: home_visit !== null && 'V_S' in home_visit && 'BP_2' in home_visit.V_S && 'value_2' in home_visit.V_S.BP_2 && home_visit.V_S.BP_2.value_2 !== '' && home_visit.V_S.BP_2.value_2 !== null && home_visit.V_S.BP_2.value_2 !== undefined ? home_visit.V_S.BP_2.value_2 : ''
        },
        RR: {
          value_1: home_visit !== null && 'V_S' in home_visit && 'RR' in home_visit.V_S && 'value_1' in home_visit.V_S.RR && home_visit.V_S.RR.value_1 !== '' && home_visit.V_S.RR.value_1 !== null && home_visit.V_S.RR.value_1 !== undefined ? home_visit.V_S.RR.value_1 : '',
        },
        PR: {
          value_1: home_visit !== null && 'V_S' in home_visit && 'PR' in home_visit.V_S && 'value_1' in home_visit.V_S.PR && home_visit.V_S.PR.value_1 !== '' && home_visit.V_S.PR.value_1 !== null && home_visit.V_S.PR.value_1 !== undefined ? home_visit.V_S.PR.value_1 : '',
        },
        BW: {
          value_1: home_visit !== null && 'V_S' in home_visit && 'BW' in home_visit.V_S && 'value_1' in home_visit.V_S.BW && home_visit.V_S.BW.value_1 !== '' && home_visit.V_S.BW.value_1 !== null && home_visit.V_S.BW.value_1 !== undefined ? home_visit.V_S.BW.value_1 : '',
        },
        HT: {
          value_1: home_visit !== null && 'V_S' in home_visit && 'HT' in home_visit.V_S && 'value_1' in home_visit.V_S.HT && home_visit.V_S.HT.value_1 !== '' && home_visit.V_S.HT.value_1 !== null && home_visit.V_S.HT.value_1 !== undefined ? home_visit.V_S.HT.value_1 : '',
        },
      }

      this.general_condition = {
        status: home_visit !== null && 'general_condition' in home_visit && 'status' in home_visit.general_condition && home_visit.general_condition.status !== '' && home_visit.general_condition.status !== null && home_visit.general_condition.status !== undefined ? home_visit.general_condition.status : '',
        title: home_visit !== null && 'general_condition' in home_visit && 'title' in home_visit.general_condition && home_visit.general_condition.title !== '' && home_visit.general_condition.title !== null && home_visit.general_condition.title !== undefined ? home_visit.general_condition.title : '',
        detail: home_visit !== null && 'general_condition' in home_visit && 'detail' in home_visit.general_condition && home_visit.general_condition.detail !== '' && home_visit.general_condition.detail !== null && home_visit.general_condition.detail !== undefined ? home_visit.general_condition.detail : '',
      }
      this.problems = home_visit !== null && 'problems' in home_visit && home_visit.problems !== null && home_visit.problems.length !== 0 && home_visit.problems !== undefined ? home_visit.problems : this.problems = [{ problems_encountered: '', nursing_goals: '', nursing: '', nursing_results: ''}],
      // this.problems_encountered = 'problems_encountered' in home_visit && home_visit.problems_encountered !== '' && home_visit.problems_encountered !== null && home_visit.problems_encountered !== undefined ? home_visit.problems_encountered : '',
      // this.nursing_goals = 'nursing_goals' in home_visit && home_visit.nursing_goals !== '' && home_visit.nursing_goals !== null && home_visit.nursing_goals !== undefined ? home_visit.nursing_goals : '',
      // this.nursing = 'nursing' in home_visit && home_visit.nursing !== '' && home_visit.nursing !== null && home_visit.nursing !== undefined ? home_visit.nursing : '',
      // this.nursing_results = 'nursing_results' in home_visit && home_visit.nursing_results !== '' && home_visit.nursing_results !== null && home_visit.nursing_results !== undefined ? home_visit.nursing_results : '',
      this.next_visit_plans = home_visit !== null && 'next_visit_plans' in home_visit && home_visit.next_visit_plans !== '' && home_visit.next_visit_plans !== null && home_visit.next_visit_plans !== undefined ? home_visit.next_visit_plans : '',
      this.next_visit_time = home_visit !== null && 'next_visit_time' in home_visit && home_visit.next_visit_time !== '' && home_visit.next_visit_time !== null && home_visit.next_visit_time !== undefined ? home_visit.next_visit_time : moment().add(1, 'days').format("YYYY-MM-DD"),
      this.reciver_service_name = home_visit !== null && 'reciver_service_name' in home_visit && home_visit.reciver_service_name !== '' && home_visit.reciver_service_name !== null && home_visit.reciver_service_name !== undefined ? home_visit.reciver_service_name : '',

      this.edit = false
      this.user = {
        name: 'fullname' in item && item.fullname !== '' && item.fullname !== null && item.fullname !== undefined ? item.fullname : '',
        one_id: 'one_id' in item && item.one_id !== '' && item.one_id !== null && item.one_id !== undefined ? item.one_id : '',
        signature_user: home_visit !== null && 'user' in home_visit && 'signature_user' in home_visit.user && home_visit.user.signature_user !== '' && home_visit.user.signature_user !== null && home_visit.user.signature_user !== undefined ? home_visit.user.signature_user : '',
        file_id_user_image: home_visit !== null && 'user' in home_visit && 'file_id_user_image' in home_visit.user && home_visit.user.file_id_user_image !== '' && home_visit.user.file_id_user_image !== null && home_visit.user.file_id_user_image !== undefined ? home_visit.user.file_id_user_image : '',
      }

      this.edit2 = false
      this.staff_service = {
        name: sessionStorage.getItem('accountName'),
        position: sessionStorage.getItem('role_name'),
        signature_staff: home_visit !== null && 'staff_service' in home_visit && 'signature_staff' in home_visit.staff_service && home_visit.staff_service.signature_staff !== '' && home_visit.staff_service.signature_staff !== null && home_visit.staff_service.signature_staff !== undefined ? home_visit.staff_service.signature_staff : '',
        file_id_staff_image: home_visit !== null && 'staff_service' in home_visit && 'file_id_staff_image' in home_visit.staff_service && home_visit.staff_service.file_id_staff_image !== '' && home_visit.staff_service.file_id_staff_image !== null && home_visit.staff_service.file_id_staff_image !== undefined ? home_visit.staff_service.file_id_staff_image : '',
      }

      if (home_visit !== null && 'user' in home_visit && 'file_id_user_image' in home_visit.user && home_visit.user.file_id_user_image !== '' && home_visit.user.file_id_user_image !== null && home_visit.user.file_id_user_image !== undefined) {
        await this.get_img_onebox(home_visit.user.file_id_user_image, 'user')

        if (this.user_image_HTML !== '') {
          this.user.signature_user = this.user_image_HTML
        }
      } else {
        if (home_visit !== null && 'user' in home_visit && 'signature_user' in home_visit.user && home_visit.user.signature_user !== '' && home_visit.user.signature_user !== null && home_visit.user.signature_user !== undefined) {
          this.user.signature_user = home_visit.user.signature_user
        } else {
          this.user.signature_user = ''
        }
      }

      if (home_visit !== null && 'staff_service' in home_visit && 'file_id_staff_image' in home_visit.staff_service && home_visit.staff_service.file_id_staff_image !== '' && home_visit.staff_service.file_id_staff_image !== null && home_visit.staff_service.file_id_staff_image !== undefined) {
        await this.get_img_onebox(home_visit.staff_service.file_id_staff_image, 'staff')

        if (this.staff_image_HTML !== '') {
          this.staff_service.signature_staff = this.staff_image_HTML
        }
      } else {
        if (home_visit !== null && 'staff_service' in home_visit && 'signature_staff' in home_visit.staff_service && home_visit.staff_service.signature_staff !== '' && home_visit.staff_service.signature_staff !== null && home_visit.staff_service.signature_staff !== undefined) {
          this.staff_service.signature_staff = home_visit.staff_service.signature_staff
        } else {
          this.staff_service.signature_staff = ''
        }
      }

      this.slide = 0
      this.getFlie(value)
    },
    async get_img_onebox(item, text) {
      try {
        const params = new URLSearchParams();
        params.append("file_id", item);

        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/download_home_visit_one_box?${params}`).then((res) => {
          console.log('onebox', res);
          if (res.data.result == 'success' && res.data.code == 200) {
            if (res.data.data !== '' && res.data.data !== null && res.data.data !== undefined) {
              if (text == 'user') {
                this.user_image_HTML = 'data:image/png;base64,' + res.data.data
              } else if (text == 'staff') {
                this.staff_image_HTML = 'data:image/png;base64,' + res.data.data
              }
            } else {
              if (text == 'user') {
                this.user_image_HTML = ''
              } else if (text == 'staff') {
                this.staff_image_HTML = ''
              }
            }
          }
        })
      } catch(err) {
        console.log(err);
      }
    },
    async getFlie(value) {
      try {
        var params = new URLSearchParams()
        params.append('template_id', value.template_id)
        params.append('biz_id', this.item.biz_id)

        await this.axios.get(`${process.env.VUE_APP_BACKEND_URL}/v1/get_file?${params}` ,
        ).then((res) => {
          console.log('res getFlie', res);
          if (res.data.result === "success" && res.data.code === 200) {
            if (res.data.data.files && res.data.data.files.length !== 0) {
              this.files = res.data.data.files
              this.span_files = false
            } else {
              this.files = []
              this.span_files = true
            }
            this.authen_token = res.data.data.authen_token
          } else if (res.data.result === "fail" && res.data.code === 200) {
              this.files = []
              this.span_files = true
          }
        })
      } catch (error) {
         console.log('error', error);
      }
    },
    async downloadFile(index) {
      try {
        var params = new URLSearchParams()
        params.append('file_id', this.files[index].id)

        await this.axios.get(`https://box.one.th/onebox_uploads/api/dowloads_file?${params}`,
        {
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${this.authen_token}`,
          }
        }).then((res) => {
          // console.log('downloadFile', res);
          // console.log('res.data', res.data);
          if (res.status === 200) {
            const label = this.files[index].filename
            const blob = new Blob([res.data], { type: res.data.type })
            const link = document.createElement('a')
            link.href = URL.createObjectURL(blob)
            link.download = label
            link.click()
            URL.revokeObjectURL(link.href)
            
          } else {
            this.$swal({
              title:
                "<span style='color: black;font-size: 18px;font-family: Sarabun, sans-serif;'>ผิดพลาด</span>",
              icon: "error",
              showCloseButton: false,
              showConfirmButton: false,
              background: "white",
              timer: 3000,
            });
          }
        })
      } catch (error) {
         console.log('error', error);
      }
    },
    set_value() {
      this.set_hour.push('00')
      for(var i=1; i<=23; i++) {
        if(i < 10) {
          this.set_hour.push('0'+i.toString())
        } else {
          this.set_hour.push(i.toString())
        }
      }
      this.set_min.push('00')
      for(var j=1; j<=59; j++) {
        if(j < 10) {
          this.set_min.push('0'+j.toString())
        } else {
          this.set_min.push(j.toString())
        }
      }
    },
    displayDate() {
      var year1 = ""
      var year2 = ""
      if (!this.nursing_activity_no.date) return;
        year1 = moment(this.nursing_activity_no.date).locale("th").format("YYYY")
        year2 = (parseInt(year1) + 543).toString()
        return moment(this.nursing_activity_no.date).locale("th").format("DD/MM/" + year2)
    },
    clearDaySelect() {
      this.nursing_activity_no.date = null;
      this.day_menu = false;
      this.activePicker = null
    },
    displayDate2() {
      var year11 = ""
      var year22 = ""
      if (!this.next_visit_time) return;
        year11 = moment(this.next_visit_time).locale("th").format("YYYY")
        year22 = (parseInt(year11) + 543).toString()
        return moment(this.next_visit_time).locale("th").format("DD/MM/" + year22)
    },
    clearDaySelect2() {
      this.next_visit_time = null;
      this.day_menu2 = false;
      this.activePicker2 = null
    },
    onEnd() {
      const { isEmpty } = this.$refs.signatureUser.saveSignature();
      if (isEmpty === true) {
        this.isWrite = false;
        const { isEmpty } = this.$refs.signatureStaff.saveSignature();
        if (isEmpty === true) {
          this.isWrite2 = false;
        } else {
          this.isWrite2 = true;
        }
      } else {
        this.isWrite = true;
      }
    },
  }
}
</script>

<style scoped>
::v-deep .set-checkbox .v-input--selection-controls__input {
  align-self: start !important;
}

.border-card-00A99D {
  border: 2px solid #00A99D;
}

::v-deep .v-textarea textarea{
  color: #333333 !important;
}
</style>